import React from "react";

function ShareScreen() {
  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="bg-blue-50 p-6 rounded-lg mb-6">
        <h2 className="text-lg font-bold text-blue-800 mb-2">Share Screen</h2>
        <p className="text-xs text-gray-600">
          Enter the AnyDesk ID to connect to a remote screen. Click "Connect" to initiate the session.
        </p>
      </div>

      {/* Form Section */}
      <div className="bg-white p-6 rounded-lg shadow border border-gray-300">
        <div className="flex flex-col md:flex-row items-center gap-4">
          <label htmlFor="anydeskId" className="text-xs text-gray-700 font-medium">
            AnyDesk ID:
          </label>
          <input
            type="text"
            id="anydeskId"
            placeholder="Enter AnyDesk ID"
            className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-xs"
          />
          <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition text-xs">
            Connect
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShareScreen;